/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Payment_Choice_Modal_Pay_Advance_DescriptionInputs */

const es_components_payment_choice_modal_pay_advance_description = /** @type {(inputs: Components_Payment_Choice_Modal_Pay_Advance_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagá varios meses de una vez y accedé a descuentos exclusivos.`)
};

const en_components_payment_choice_modal_pay_advance_description = /** @type {(inputs: Components_Payment_Choice_Modal_Pay_Advance_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pay multiple months at once and get exclusive discounts.`)
};

/**
* | output |
* | --- |
* | "Pay multiple months at once and get exclusive discounts." |
*
* @param {Components_Payment_Choice_Modal_Pay_Advance_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_payment_choice_modal_pay_advance_description = /** @type {((inputs?: Components_Payment_Choice_Modal_Pay_Advance_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Payment_Choice_Modal_Pay_Advance_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_payment_choice_modal_pay_advance_description(inputs)
	return en_components_payment_choice_modal_pay_advance_description(inputs)
});
export { components_payment_choice_modal_pay_advance_description as "components.payment_choice_modal.pay_advance_description" }